import React from 'react';
import Icon from 'style/fonts/glyphmaps/icon.component';

export default function IconCounter({ clickCount, containerStyle, ...props }) {
  return (
    <div
      className="flex-row align-center justify-center"
      style={containerStyle}
    >
      <Icon {...props} />

      {clickCount || 0}
    </div>
  );
}
